export const font1 = {
    " ": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ]
    ],
    "!": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "\"": [
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "#": [
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "$": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "%": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "&": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "'": [
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ]
    ],
    "(": [
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    ")": [
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "*": [
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "+": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    ",": [
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ]
    ],
    "-": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    ".": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "/": [
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "0": [
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "1": [
        [
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ]
    ],
    "2": [
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "3": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "4": [
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "5": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "6": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "7": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "8": [
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "9": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    ":": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ]
    ],
    ";": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "<": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "=": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    ">": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "?": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "@": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "A": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "B": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "C": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "D": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "E": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "F": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "G": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "H": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "I": [
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ]
    ],
    "J": [
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "K": [
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "L": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "M": [
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "N": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "O": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "P": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "Q": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "R": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "S": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "T": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "U": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "V": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "W": [
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "X": [
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "Y": [
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "Z": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "[": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "\\": [
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "]": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "^": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "_": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "`": [
        [
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ]
    ],
    "a": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "b": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "c": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "d": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "e": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "f": [
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "g": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "h": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "i": [
        [
            0.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ]
    ],
    "j": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "k": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "l": [
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ]
    ],
    "m": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "n": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "o": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "p": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "q": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "r": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ]
    ],
    "s": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "t": [
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "u": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "v": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "w": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "x": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "y": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "z": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "{": [
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "|": [
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ]
    ],
    "}": [
        [
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "~": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u007f": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0080": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0081": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0082": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0083": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0084": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0085": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0086": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0087": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0088": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0089": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u008a": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u008b": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u008c": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u008d": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u008e": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u008f": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0090": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0091": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0092": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0093": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0094": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0095": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0096": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0097": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0098": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u0099": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u009a": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u009b": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u009c": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u009d": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u009e": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u009f": [
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            1.0
        ]
    ],
    "\u00a0": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00a1": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00a2": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00a3": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00a4": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00a5": [
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00a6": [
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            1.0,
            0.0
        ]
    ],
    "\u00a7": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00a8": [
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00a9": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00aa": [
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00ab": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00ac": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00ad": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00ae": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00af": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b0": [
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b1": [
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b2": [
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b3": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b4": [
        [
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b5": [
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00b6": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00b7": [
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            1.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ],
        [
            0.0,
            0.0
        ]
    ],
    "\u00b8": [
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00b9": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00ba": [
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00bb": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00bc": [
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00bd": [
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00be": [
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ]
    ],
    "\u00bf": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00c0": [
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c1": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c2": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c3": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c4": [
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c5": [
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c6": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c7": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00c8": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00c9": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00ca": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00cb": [
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00cc": [
        [
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00cd": [
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00ce": [
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00cf": [
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d0": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d1": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00d2": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d3": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d4": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d5": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d6": [
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d7": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00d8": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00d9": [
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00da": [
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00db": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00dc": [
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00dd": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00de": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00df": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00e0": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e1": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e2": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e3": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e4": [
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e5": [
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e6": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00e7": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00e8": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00e9": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00ea": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00eb": [
        [
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00ec": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0
        ]
    ],
    "\u00ed": [
        [
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00ee": [
        [
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00ef": [
        [
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f0": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f1": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00f2": [
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f3": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f4": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f5": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f6": [
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00f7": [
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00f8": [
        [
            0.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00f9": [
        [
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00fa": [
        [
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00fb": [
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00fc": [
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            1.0,
            0.0
        ]
    ],
    "\u00fd": [
        [
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ],
    "\u00fe": [
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ]
    ],
    "\u00ff": [
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            0.0,
            0.0,
            0.0,
            0.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0,
            0.0
        ],
        [
            1.0,
            1.0,
            1.0,
            0.0,
            0.0
        ],
        [
            0.0,
            1.0,
            1.0,
            0.0,
            0.0
        ]
    ]
}